import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';

export const MiniProductListPlaceholder = ({ isFull, numberOfItems = 12 }) => {
  return (
    <Skeleton grow disablePadding>
      {
        isFull && (
          <>
            <div className="sui-w-40">
              <SkeletonLine fullWidth TypographyProps={{ variant: 'h4' }} variant="heading" />
            </div>
            <SkeletonBlock aspect="wide" height={12} />
          </>
        )
      }
      {
        numberOfItems > 0 && (
          <>
            {
              new Array(numberOfItems).fill(0).map((placeholder, index) => (
                <SkeletonBlock aspect="wide" height={10} key={`skel-${index}`} />
              ))
            }
          </>
        )
      }
    </Skeleton>
  );
};

MiniProductListPlaceholder.propTypes = {
  isFull: PropTypes.bool.isRequired,
  numberOfItems: PropTypes.number
};

MiniProductListPlaceholder.defaultProps = {
  numberOfItems: 12
};
